/* eslint-disable */
import { useLayoutEffect, useEffect, useState, useContext } from 'react'
import styles from './index.module.scss'
import PageHeader from '../../components/pages/header'
import Breadcrumb from '../../components/core/breadcrumb'
import Services from '../../components/pages/services'
import { ServiceCard } from '../../components/core/cards'
import PageTitle from '../../components/core/pageTitle'
import { Button } from '../../components/core/button'
import { useParams } from 'react-router-dom'
import { PageContext } from '../../context/PageContextProvider'
import ServicesAPI from '../../api/services'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'

const Service = ({ className }) => {
  const { language } = useContext(PageContext)
  let { id } = useParams()
  const [current, setCurrent] = useState(id || 1)
  const [width, setWidth] = useState(false)
  const DEFAULT_INFO = {
    title: {
      AZ: 'Xidmət əldə edin',
      ENG: 'Get Service',
      RU: 'Получить услугу',
      TR: 'Hizmet Alın',
    },
    description_az: 'Biznesiniz üçün ən uyğun xidmət paketini seçin və mütəxəssislərimiz sizinlə əlaqə saxlasın.',
    description_eng: 'Choose the most suitable service package for your business and our specialists will contact you.',
    description_ru: 'Выберите наиболее подходящий пакет услуг для вашего бизнеса, и наши специалисты свяжутся с вами.',
    description_tr: 'İşletmeniz için en uygun danışmanlık paketini seçin, uzmanlarımız sizinle iletişime geçsin.',
  }
  const [load, setLoad] = useState(false)
  const [services, setServices] = useState([])
  const [info, setInfo] = useState(DEFAULT_INFO)
  useEffect(() => {
    (async () => {
      try {
        const { data } = await ServicesAPI.getAll()
        setServices(data || [])
      } catch (e) {
        console.error('Error fetching services:', e)
      }
      try {
        const data1 = await PagesAPI.getGetService()
        if (data1?.data?.title) {
          setInfo(data1.data)
        }
      } catch (e) {
        console.warn('Using default getService info')
      }
      setLoad(true)
    })()
  }, [])
  useEffect(() => {
    setCurrent(id || 1)
  }, [id])
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 767) {
        setWidth(true)
        return
      }
      setWidth(false)
    }

    window.addEventListener('resize', updateSize)
    updateSize()
  }, [])
  const details = {
    AZ: 'Detallar',
    ENG: 'Details',
    RU: 'Детали',
    TR: 'Detaylar',
  }
  const button = {
    AZ: 'Xidmət əldə edin',
    ENG: 'Get service',
    RU: 'Получить услугу',
    TR: 'Hizmet Alın',
  }
  const currentService = (services && services[parseInt(current) - 1]) || (services && services[0])
  const serviceTitle = currentService?.service_name?.[language] || (language === 'AZ' ? 'Xidmətlər' : language === 'TR' ? 'Hizmetler' : language === 'RU' ? 'Услуги' : 'Services')

  return load ? (
    <section className={`${className} ${styles.container}`}>
      <div className={styles.content}>
        {width ? (
          <Services id={current} />
        ) : (
          <div className={styles.services}>
            {services && services.length > 0 ? (
              <>
                <div>
                  <span>{details[language] || details.TR || details.AZ}</span>
                  <h2>{(services[current - 1] || services[0])?.service_name?.[language] || ''}</h2>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: (services[current - 1] || services[0])
                        ? (language === 'AZ'
                          ? (services[current - 1] || services[0]).description_az
                          : language === 'TR'
                          ? ((services[current - 1] || services[0]).description_tr || (services[current - 1] || services[0]).description_az)
                          : language === 'ENG'
                          ? (services[current - 1] || services[0]).description_eng
                          : (services[current - 1] || services[0]).description_ru)
                        : '',
                    }}
                  />
                </div>
                <div>
                  {services.map((item, i) => (
                    <ServiceCard
                      key={i + 1}
                      active={parseInt(current) === i + 1}
                      click={() => {
                        setCurrent(i + 1)
                      }}
                      name={item.service_name?.[language] || ''}
                      link={`/services/${i + 1}`}
                    />
                  ))}
                </div>
              </>
            ) : null}
          </div>
        )}
      </div>
      <div className={styles['get-service']}>
        <PageTitle>{info?.title?.[language] || info?.title?.TR || info?.title?.AZ || ''}</PageTitle>
        <p
          dangerouslySetInnerHTML={{
            __html:
              language === 'AZ'
                ? info?.description_az || ''
                : language === 'TR'
                ? info?.description_tr || info?.description_az || ''
                : language === 'ENG'
                ? info?.description_eng || ''
                : info?.description_ru || '',
          }}
        />
        <Button to={'/get-service1'}>{button[language] || button.TR || button.AZ}</Button>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Service
